/** Feature asset URLs resolved by Vite. */
export { default as FIND_RIDE_BACKGROUND_URL } from "../assets/Findride_background.png";

export const FIND_RIDE_HEADER_OFFSET = "4rem"; // landing header h-16
